module.exports = __webpack_public_path__ + "img/charging station.9c7bc0e4.png";